import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import MisLobby from './MisLobby';
import MisTableView from './MisTableView';
import MisPersonaRoster from './MisPersonaRoster';
import MisPcRoster from './MisPcRoster';

class Misanthropy extends Component {
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route exact path={`${match.path}/personas`} component={MisPersonaRoster} />
        <Route exact path={`${match.path}/pcs`} component={MisPcRoster} />
        <Route path={`${match.path}/sessions/:sessionId`} component={MisTableView} />
        <Route component={MisLobby} />
      </Switch>
    );
  }
}

export default Misanthropy;
